import { TextField } from 'mui-rff';
import React from 'react';

import Form from '@dashboard/components/form/Form';
import PermissionTooltip from '@dashboard/components/PermissionTooltip';
import BaseSettingCard from '@dashboard/components/platform-settings/BaseSettingCard';
import { useUpdatePlatformConfigurationMutation } from '@dashboard/generated/wp/authentication';
import useCurrentWpPlatform from '@dashboard/hooks/useCurrentWpPlatform';
import { Box, Button } from '@mui/material';

import { usePermission } from '../hooks';

type TForm = {
  name: string;
  description: string;
};
export default function PlatformConfigurationEdit(): JsxNode {
  const { data } = useCurrentWpPlatform();
  const model = data?.Platform;
  const [updateConfiguration, { loading }] = useUpdatePlatformConfigurationMutation();
  const permission = usePermission('updatePlatformInformation');

  if (model === undefined) {
    return null;
  }

  const { name, description, id } = model;
  const initialValues: TForm = { name, description: description ?? '' };

  async function onSubmit(f: TForm) {
    await updateConfiguration({ variables: { ...f, platformId: id } });
  }

  return (
    <BaseSettingCard title="General">
      <Form successMessage="Platform settings saved" initialValues={initialValues} onSubmit={onSubmit}>
        <TextField margin="normal" disabled={loading || !permission} name="name" label="Workspace name" fullWidth />
        <TextField
          margin="normal"
          disabled={loading || !permission}
          name="description"
          label="Workspace description"
          fullWidth
        />
        <Box mt={2}>
          <PermissionTooltip span name="updatePlatformInformation">
            <Button disabled={loading || !permission} type="submit" variant="contained">
              Save
            </Button>
          </PermissionTooltip>
        </Box>
      </Form>
    </BaseSettingCard>
  );
}
